module.exports = __webpack_public_path__ + "static/media/date.5fdd9e8e.svg";